import React, { Component } from 'react';
import Helmet from 'react-helmet';
import _, { filter } from 'lodash';
import DealerAddress from './DealerAddress';
import BuyingSites from './BuyingSites';
import addressData from './addressData.json';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import ButtonLink from '../common/TrackedButtonLink';
import TrackedLink from "../common/TrackedLink";

class WhereToBuyIntl extends Component {
	constructor(props) {
		super(props);
		this.state = {
			address: null
		};
	}

	handleChange(e) {
		let addresses = addressData;
		const element = e.target;
		addresses = filter(addresses, ['id', element.value]);
		if (addresses !== null) {
			const addressVal = addresses.map(
				(address, index) => <DealerAddress key={index} address={address} />
			);
			this.setState({
				address: addressVal
			});
		}
		global.dataLayer.push({
			event: 'Where to Buy',
			eventCategory: 'Where to Buy',
			eventAction: 'Dropdown',
			eventLabel: element.options[element.selectedIndex].text
		});
	}

	render() {
		return (
			<div className="where-to-buy">

				<Helmet>
					<title>Where To Buy - International Retailers &#124; SentrySafe</title>
					<meta name="description" content="SentrySafe offers a variety of products to countries all around the world. Let us help you find a retailer near you." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Where to Buy International" />
				</Breadcrumb>

				<header className="row header-callout">
					<div className="col">
						<h1>Where to Buy</h1>
						<p>Our retailers offer a wide selection of SentrySafe products to meet your needs. Browse our preferred retailers.</p>
					</div>
				</header>

				<section className="preferred-retailers">
					<div className='row'>
						<div className="col text-center">
							<h2 className="pt-3 pb-2">Our Preferred Retailers</h2>
							<p>View International Distributors below. Visit this page to <TrackedLink to="/where-to-buy">view U.S and Canada Retailers</TrackedLink>.</p>
						</div>
					</div>
					<div className="row">

						<div className="col pt-5">

							<BuyingSites region="United Kingdom" />
							<div className="international-distributors">
								<div className="row">
									<div className="col">
										<p>
											If you are looking for a contact for one of our international distributors and agents,
											please select a territory from the list below, and a list of all of the pertinent
											contacts from that area will show up. Distributors and agents can provide a list of
											retailers who carry the SentrySafe products.
										</p>
										<label htmlFor="address" className="assistive-text">
											Select a Territory
										</label>
										<select
											className="address-list"
											id="address"
											name="address"
											onChange={e => this.handleChange(e)}
										>
											<option value="">-- Select a Territory --</option>
											<option value="AL">Algeria</option>
											<option value="AN">Angola</option>
											<option value="ANP">Australia - New Zealand - Papua New Guinea - Fiji, Somoa - Tonga</option>
											<option value="BAH">Bahrain</option>
											<option value="CN">China</option>
											<option value="CY">Cyprus</option>
											<option value="EG">Egypt</option>
											<option value="FR">France</option>
											<option value="GR">Greece</option>
											<option value="GM">Germany</option>
											<option value="HK">Hong Kong / Macau</option>
											<option value="ID">Indonesia</option>
											<option value="IS">Israel</option>
											<option value="JP">Japan</option>
											<option value="JD">Jordan</option>
											<option value="KU">Kuwait</option>
											<option value="LB">Lebanon</option>
											<option value="MR">Morocco</option>
											<option value="OM">Oman</option>
											<option value="PP">Philippines</option>
											<option value="QR">Qatar</option>
											<option value="RM">Rep. Of Maldives</option>
											<option value="SAU">Saudia Arabia</option>
											<option value="SMB">Singapore, Malaysia and Brunei</option>
											<option value="TW">Taiwan</option>
											<option value="TLM">Thailand, Laos &amp; Myanmar</option>
											<option value="UAE">UAE</option>
											<option value="UC">United States and Canada</option>
											<option value="VT">Vietnam</option>
										</select>
										{this.state.address}
									</div>
								</div>
							</div>

						</div>
					</div>
				</section >
			</div >
		);
	}
};

export default WhereToBuyIntl;


// WEBPACK FOOTER //
// ./src/pages/whereToBuy/International.js